import ScrollMagic from "scrollmagic";

jQuery(function () {
  
  let slideDuration  = 300,
      sliderTop = jQuery('.front-info').length ? jQuery('.front-info').offset().top : 0;

  let Scroll = (function () {
	let scroll         = {},
      controller     = null;

  

    let createSlideScreenShots = function () {
      let screensContainer = new ScrollMagic.Scene({
        duration: 700,
        triggerElement: '.front-app',
        offset: 160,
        triggerHook: 0.1,
      })
      .setPin('.front-app')
      .addTo(controller);

      let screen1 = new ScrollMagic.Scene({
        triggerElement: '.front-app',
        offset: 100,
        triggerHook: 0.1
      })
      .setClassToggle('#screen1','active')
      .addTo(controller);

      let screen2 = new ScrollMagic.Scene({
        triggerElement: '.front-app',
        offset: 400,
        triggerHook: 0.1
      })
      .setClassToggle('#screen2','active')
      .addTo(controller);

      let screen3 = new ScrollMagic.Scene({
        triggerElement: '.front-app',
        offset: 700,
        triggerHook: 0.1
      })
      .setClassToggle('#screen3','active')
      .addTo(controller);
    };


    scroll.destroyScroll = function () {
      if (!controller) return;
      controller.destroy(true);
      controller = null;
    };

    scroll.initScroll = function () {
      if (controller) return;
      controller     = new ScrollMagic.Controller();

      createSlideScreenShots();

    };

  	return scroll;
  }());

// Scroll Magic!

  let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (w < 1024) {
    console.log("LOAD PAGE MOBILE [] && IPAD [ ] ")
    Scroll.destroyScroll();
  } else {
    console.log("LOAD PAGE DESKTOP [   ] ")
    Scroll.initScroll();
  }
  window.onresize = function() {
    w = jQuery(window).width();
    console.info("window [ ]",w)
    if (w < 1024) {
      console.log("MOBILE [] && IPAD [ ] ")
      Scroll.destroyScroll();
    } else {
      console.log("DESKTOP [   ] ")
      Scroll.initScroll();
    }
  };
});
